<template>
	<div class="top-div">
		<div class="text-center">
			<img class="icon" src="../../../../assets/image/create-icon.png" />
			<div>
				<p class="text">{{$t('user.createwallet.prepare.slogan')}}</p>
				<p class="text">{{$t('user.createwallet.prepare.tip')}}</p>
			</div>
			<button class="blue-btn" @click="createWallet()">{{$t('user.createwallet.prepare.crebtn')}}</button>
			<!-- <button class="white-btn">
				{{$t('user.createwallet.prepare.already')}}
				<span class="blue-text" @click="importWallet()">{{$t('user.createwallet.prepare.import')}}</span>
			</button> -->
		</div>
	</div>
</template>
<script>
export default {
	methods: {
		createWallet() {
			this.$emit("next", "Create");
		},
		importWallet() {
			// ...todo
			console.log("importWallet");
		},
	},
};
</script>

<style lang="sass" scoped>
.top-div
  margin-top: 12.2rem
  .icon
    width: 13.2rem
    margin: 5rem 0 4.3rem 0
  .text
    font-size: 1.4rem
    font-weight: 400
    color: #333333
    margin:auto
    line-height: 2.8rem
  .blue-btn
    outline: none
    width: 100%
    height: 4.9rem
    background: #DC472A
    border-radius: 0.4rem
    border: none
    color: #ffffff
    margin: 5.5rem 0 1rem 0
  .white-btn
    outline: none
    width: 100%
    height: 4.9rem
    background: #ffffff
    border-radius: 0.4rem
    color: #838383
    border: 0.1rem solid #E5E5E5
    .blue-text
      color: #DC472A
      font-weight:bold
</style>